// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___2d8c408902d07391f2d","cls2":"ToolsMenu-cls2___fbdb11f8dd9ce5ae17a ToolsMenu-cls1___2d8c408902d07391f2d"};